import { render, staticRenderFns } from "./BrowseQuickSearch.vue?vue&type=template&id=336ea494"
import script from "./BrowseQuickSearch.vue?vue&type=script&lang=ts"
export * from "./BrowseQuickSearch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('336ea494')) {
      api.createRecord('336ea494', component.options)
    } else {
      api.reload('336ea494', component.options)
    }
    module.hot.accept("./BrowseQuickSearch.vue?vue&type=template&id=336ea494", function () {
      api.rerender('336ea494', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/browse/BrowseQuickSearch.vue"
export default component.exports